// src/config/app/teamConfig.js
import React from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import SpaIcon from '@mui/icons-material/Spa';
import GavelIcon from '@mui/icons-material/Gavel';

export const chatTeamConfigs = {
  'active_workout_team': {
    autoOpenResourceTypes: ['workout_session', 'workout_plan'], 
    nonClosableResourceTypes: ['workout_session', 'workout_plan', 'location'],
    suppressGlobalAlerts: true,
    headerButtons: {
      audio: true,
      save: false,
      new: false,
      custom: []
    },
    widgets: ['stopwatch', 'timer', 'audioController', 'weightCalculator', 'timeSinceLastActivity'],
  },
  'interactive_workout_plan_team': {
    autoOpenResourceTypes: ['workout_plan'],
    nonClosableResourceTypes: ['workout_plan'],
    widgets: ['audioController'],
  },
  'onboarding_team': {
    widgets: [],
    headerButtons: { audio: false, save: false, new: false },
    disableAILimitationsNotice: true
  },
  'legal_team': {
    widgets: [],
    headerButtons: { audio: false, save: false, new: false },
    disableAILimitationsNotice: true
  }
};

export const teamSidebarConfigs = {
  'interactive_workout_plan_team': {
    title: 'Design Workout',
    icon: <AssignmentIcon />,
    id: 'design_workout'
  },
  'active_workout_team': {
    title: 'Workout Session',
    icon: <SportsGymnasticsIcon />,
    id: 'workout_session'
  },
  'onboarding_team': {
    title: 'Profile Setup',
    icon: <SpaIcon />,
    id: 'onboarding'
  },
  'legal_team': {
    title: 'Terms & Agreements',
    icon: <GavelIcon />,
    id: 'legal'
  }
};